
import { withCellStyles, getCell, formats } from "../../../utils";
import { BudgetModalTemplateCurrentState, BmTemplateInternals } from "../budget-helper-internal";
import { Rows } from "../../../interfaces";
import { centeredBoldGrayForHeaders } from "../../../excelStyles";
import { BudgetModelFormGroup } from "../../../../models/budget-model/pojo/bm-form";

export class BeforeMainDataSection {
  private readonly TOTAL_HEADERS = ['Total', '% of Capital required', '% of commitment'];
  private readonly BUDGET_HEADER = ['Budget'];
  private current: BudgetModalTemplateCurrentState;
  constructor(
    private readonly helper: BmTemplateInternals,
    private readonly budgetForm: BudgetModelFormGroup,
  ) { }

  fillRowsBeforeMainData(rows: Rows): void {
    let headers = this.getHeadersWithTotals(this.budgetForm);
    headers = this.helper.insertNullValuesInToHeadersAfterYear(headers);
    this.current = this.helper.defineCurrent(this.budgetForm, headers);
    this.prepareRowsBeforeHeaders(rows, headers);
  }

  getCurrent(): BudgetModalTemplateCurrentState {
    return this.current;
  }

  private getHeadersWithTotals(budgetForm: BudgetModelFormGroup): string[] {
    return this.BUDGET_HEADER
      .concat(budgetForm.value.modelHeaders.map((p) => p.headerText))
      .concat(this.TOTAL_HEADERS);
  }

  private prepareRowsBeforeHeaders(newData: Rows, headers: string[]): void {
    newData.push(null);
    newData.push([
      withCellStyles(getCell({ v: 'Commitment', t: 's' }), centeredBoldGrayForHeaders),
      withCellStyles(getCell({ v: this.current.totalCommitment, z: formats.thousandsSeparator, t: 'n' }), centeredBoldGrayForHeaders),
    ]);
    newData.push(null);
    newData.push(headers.map((h) => withCellStyles(h, centeredBoldGrayForHeaders)));
  }
}
